import React, { Component } from "react";
import { Col, Row, Container, Card, CardHeader } from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";

import LoadingOverlay from "react-loading-overlay";
import { HUB_QRCODE } from "../../config/Constants";

export default class DeliveryQRCodeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      hubQRCode: "",
    };
  }

  componentDidMount() {
    this.checkLoginMode();
  }

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");

    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
      });
    } else {
      if (
        storeInformation.store.hubs &&
        storeInformation.store.hubs.edges &&
        storeInformation.store.hubs.edges.length > 0
      ) {
        console.log(
          "storeInformation",
          JSON.stringify(storeInformation.store.hubs.edges[0].node.id)
        );
        let hubID = HUB_QRCODE + storeInformation.store.hubs.edges[0].node.id;
        this.setState({ storeInformation: storeInformation, hubQRCode: hubID });
      }
    }
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible,
    });
  };

  render() {
    const { spinnerLoading } = this.state;

    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row style={{ marginBottom: 15 }}>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{"Scan delivery persons Qrcode"}</h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                      
                      </Col>
                    </Row>
                  </Container>
                </CardHeader>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }
  getQrcodeValue = () => {
    let QRCode = "";
    let store = this.state.storeInformation;

    if (store && store.store) {
      QRCode = store.store.id;
    }
    return QRCode;
  };
}



// WEBPACK FOOTER //
// ./src/pages/DeliveryQRCodeScreen/DeliveryQRCodeScreen.js